import flatten from 'lodash/flatten';

import {ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {SelectorType, SelectorTypeDefinitions} from 'common/widgets/query-event-selector/types';

import {Action, EntryType} from './types';

export type ResourceTrackingTypes = SelectorType | EntryType;

export const ResourceTrackingEvent: {[s in ResourceTrackingTypes]?: {[key in Action]?: string}} = {
  [ResourceType.Cohort]: {
    [Action.Add]: `Add cohort`,
    [Action.AddFilter]: `Add cohort filter`,
    [Action.Clone]: `Clone cohort`,
    [Action.Drag]: `Drag a cohort`,
    [Action.EditFilter]: `Edit cohort filter`,
    [Action.Remove]: `Remove cohort`,
    [Action.Select]: `Select cohort`,
  },
  [ResourceType.Event]: {
    [Action.Add]: `Add event`,
    [Action.AddFilter]: `Add event filter`,
    [Action.Clone]: `Clone event`,
    [Action.Drag]: `Drag an event`,
    [Action.EditFilter]: `Edit event filter`,
    [Action.Remove]: `Remove event`,
    [Action.RemoveFilter]: `Remove event filter`,
    [Action.Select]: `Select event`,
  },
  [ResourceType.User]: {
    [Action.Add]: `Add user group`,
    [Action.AddFilter]: `Add user group filter`,
    [Action.Clone]: `Clone user group`,
    [Action.Drag]: `Drag user group`,
    [Action.EditFilter]: `Edit user group filter`,
    [Action.Remove]: `Remove user group`,
    [Action.RemoveFilter]: `Remove user group filter`,
    [Action.Select]: `Select user group`,
  },
  [SelectorTypeDefinitions.EventOrUserProperty]: {
    [Action.Add]: `Add property`,
    [Action.Clone]: `Clone property`,
    [Action.Drag]: `Drag a property`,
    [Action.Remove]: `Remove property`,
    [Action.Select]: `Select property`,
  },
  [SelectorTypeDefinitions.UserProperty]: {
    [Action.Add]: `Add user property`,
    [Action.Clone]: `Clone user property`,
    [Action.Drag]: `Drag an user property`,
    [Action.Remove]: `Remove user property`,
    [Action.Select]: `Select user property`,
  },
  [SelectorTypeDefinitions.Behavior]: {
    [Action.Add]: `Add behavior`,
    [Action.AddFilter]: `Add behavior filter`,
    [Action.Clone]: `Clone behavior`,
    [Action.Drag]: `Drag a behavior`,
    [Action.EditFilter]: `Edit behavior filter`,
    [Action.Remove]: `Remove behavior`,
    [Action.RemoveFilter]: `Remove behavior filter`,
    [Action.Select]: `Select behavior`,
  },
  [SelectorTypeDefinitions.EventLaunch]: {
    [Action.Add]: `Add event`,
    [Action.AddFilter]: `Add event filter`,
    [Action.Clone]: `Clone event`,
    [Action.Drag]: `Drag an event`,
    [Action.EditFilter]: `Edit event filter`,
    [Action.Remove]: `Remove event`,
    [Action.RemoveFilter]: `Remove event filter`,
    [Action.Select]: `Select event`,
    [Action.SelectDateRange]: `Select date range`,
  },
  [EntryType.ExclusionEvent]: {
    [Action.Add]: `Add exclusion step`,
    [Action.AddFilter]: `Add exclusion step filter`,
    [Action.Clone]: `Clone exclusion step`,
    [Action.EditFilter]: `Edit exclusion step filter`,
    [Action.Remove]: `Remove exclusion step`,
    [Action.RemoveFilter]: `Remove exclusion step filter`,
    [Action.Select]: `Select exclusion step`,
  },
};

export const FlattenedResourceTrackingEvent = flatten(
  Object.values(ResourceTrackingEvent).map((entry) => Object.values(entry)),
);

export enum TrackingEvent {
  EditExclusionStepRange = `Edit exclusion step range`,
  EventIndexLabelClicked = `Event index label clicked`,
  RenameEvent = `Rename event`,
  ClearNumericProperty = `Clear numeric property`,
  SelectNumericAggregator = `Select numeric aggregator`,
  SelectNumericProperty = `Select numeric property`,
}
